// extracted by mini-css-extract-plugin
export default {"pageLayout":"Account-module__pageLayout___h48MC"};